<template>
  <div>
    <!-- <div class="header_box">
        <div class="header-right">
          <div class="custom-search">
            <input
              type="text"
              class="custom-input"
              placeholder=""
              v-model.trim="inputvalue"
              @keyup.enter="RefreshList()"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              class="custom-button"
              @click="RefreshList()"
              >搜索
            </el-button>
          </div>
        </div>
      </div> -->
    <div class="error_box">
      <div class="good-main">
        <div
          class="goods-box"
          v-for="(item, index) in errorBookList"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="good-cover">
            <el-image :src="item.coverFileUrl" fit=""></el-image>
          </div>
          <div class="good-text">
            <div class="name">{{ item.title }}</div>
            <div class="err-num">共 {{ item.questionNum }} 个错题</div>
          </div>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          class="ou-pagination"
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="searchParams.pageSize"
          layout="prev, pager, next, sizes, jumper, slot"
          :total="total"
        >
          <el-button @click="getErrorBookList()" class="ou-page-go"
            >GO</el-button
          >
        </el-pagination>
        <noData v-if="total == 0"></noData>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import noData from "@/components/noData.vue";
import {
  GetWrongQuestionListV2,
  delWrongQuestion,
} from "@/api/willingLearn/index.js";
export default {
  components: { noData },
  data() {
    return {
      inputvalue: "",
      searchParams: {
        pageNum: 1,
        pageSize: 8,
        messageTitle: "",
        isDesc: "",
        questionType: "",
      },
      value: false,
      errorBookList: [],
      total: 0,
      paperTypeList: this.paperTypeList(),
      checkList: [],
      delState: false,
      selAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    ...mapGetters(["avatar"]),
    currentSourceTypeText() {
      let dict = {
        0: "答题时间由近到远",
        1: "答题时间由远到近",
      };
      return dict[this.searchParams.isDesc];
    },
    currentSourceTypeText2() {
      let dict = this.paperTypeList;
      return dict[this.searchParams.questionType].name;
    },
  },
  mounted() {
    this.value =
      localStorage.getItem("automatically-remove") === "true" ? true : false;
    this.paperTypeList.unshift({
      name: "全部题型",
      questionType: 0,
    });
    this.getErrorBookList();
  },
  methods: {
    getErrorBookList() {
      let data = {
        pageNum: this.searchParams.pageNum,
        pageSize: this.searchParams.pageSize,
        questionType: this.searchParams.questionType,
        isDesc: this.searchParams.isDesc,
      };
      GetWrongQuestionListV2(data).then((res) => {
        this.errorBookList = res.rows;
        this.total = res.total;
        this.$emit("gettotal4", res.total);
        this.checkList = [];
        this.selAll = false;
        this.isIndeterminate = false;
      });
    },
    // 跳转
    toDetail(item) {
      let url = this.$router.resolve({
        path: "/user/errorBookV2/errDetail",
        query: {
          goodId: item.goodId,
          title: item.title,
          coverFileUrl: item.coverFileUrl,
        },
      });
      window.open(url.href, "_blank");
      // this.$router.push({
      //   path: "/willingLearn/paper/errorPaper",
      //   query: {
      //     errorBookIndex: index,
      //     questionType:
      //       this.searchParams.questionType == 0
      //         ? ""
      //         : this.searchParams.questionType,
      //     isDesc:this.searchParams.isDesc == 1 ? "1" : "0"
      //   }
      // });
    },
    checkChange(value) {
      this.isIndeterminate =
        this.checkList.length > 0 &&
        this.checkList.length < this.errorBookList.length;
      this.selAll = this.errorBookList.length === this.checkList.length;
    },
    setBtn() {
      this.delState = !this.delState;
    },
    delBtn() {
      if (this.checkList.length) {
        this.$confirm("是否要删除该错题?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          delWrongQuestion({
            questionIds: this.checkList.toString(),
          }).then(() => {
            this.getErrorBookList();
          });
        });
      } else {
        this.$message.error("请至少选中一条数据");
      }
    },
    changeAll(e) {
      this.selAll = e;
      this.isIndeterminate = false;
      let list = [];
      this.errorBookList.map((item, index) => {
        list.push(item.questionId);
      });
      this.checkList = e ? list : [];
      console.log(this.checkList);
    },

    switchChange(e) {
      localStorage.setItem("automatically-remove", e);
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getErrorBookList();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.getErrorBookList();
    },
    RefreshList() {
      this.searchParams.pageNum = 1;
      this.getErrorBookList();
    },
  },
};
</script>
<style scoped lang="scss">
.header_box {
  width: 100%;
  height: 53px;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  padding: 0 20px 0 10px;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: center;
  .header-right {
    .custom-search {
      height: auto;
      padding: 0;
      border: 0;
      .custom-input {
        border-radius: 0;
      }
      .el-button {
        border-radius: 0 !important;
      }
    }
  }
}
.switch_box {
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 6px;
  }
  .el-button {
    margin-right: 15px;
  }
  .operation_box {
    display: flex;
    align-items: center;
    div {
      display: flex;
      align-items: center;
      margin-right: 16px;
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    div:nth-child(1) {
      color: red;
    }
  }
}
.error_box {
  .good-main {
    padding: 20px;
    padding-bottom: 0;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(auto-fit, 222px);
    grid-row-gap: 25px;
    grid-column-gap: 50px;
    justify-content: flex-start;
    align-content: center;
    .goods-box {
      width: 222px;
      cursor: pointer;

      .good-cover {
        width: 100%;

        .el-image {
          width: 100%;
          height: auto;
        }
      }
      .good-text {
        .name {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .err-num {
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .card_list {
    width: calc(100% - 80px);
    height: 68px;
    border-bottom: 1px solid #f2f2f2;
    margin: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .type {
      width: 80px;
      height: 28px;
      background: #ffa83a;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      flex-shrink: 0;
    }
    .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
    }
    .checkbox {
      margin-right: 15px;
      ::v-deep .el-checkbox__label {
        display: none;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin: 25px 40px;
  }
}
</style>
